import React from "react";

function viewModule({ data }) {
  return (
     <>
        <div className="row mb-2">
          <div className="col-4 fw-bold">Name</div>
          <div className="col-8">{data?.name || "-"}</div>
        </div>
       {/* ---------- Description ---------- */}
      <div className="row mb-2">
        <div className="col-4 fw-bold">Description</div>
        <div className="col-8">{data?.description || "-"}</div>
      </div>
 
      {/* ---------- Status ---------- */}
      <div className="row mb-2">
        <div className="col-4 fw-bold">Status</div>
        <div className="col-8">
          {data?.status === 1 || data?.status === true ? (
            <span className="badge bg-success">Active</span>
          ) : (
            <span className="badge bg-danger">Inactive</span>
          )}
        </div>
      </div>
 
      {/* ---------- Todo List ---------- */}
      <div className="row mb-2">
        <div className="col-4 fw-bold">Todo List</div>
        <div className="col-8">
          {Array.isArray(data?.todo_list) && data.todo_list.length > 0 ? (
            <ol className="mb-0 ps-3">
              {data.todo_list.map((todo, index) => (
                <li key={index}>{todo}</li>
              ))}
            </ol>
          ) : (
            <span className="text-muted">-</span>
          )}
        </div>
      </div>
    </>
  );
}

export default viewModule;